/* eslint-disable  @typescript-eslint/no-explicit-any */
/* jscpd:ignore-start */
import axios from '@/plugins/axios'
import { Module } from 'vuex'

export interface Invoice {
    username: string
    token: string
}

const invoiceModule: Module<any, any> = {

    actions: {
        // Add auth headers
        async updateInvoice({ dispatch }, invoice: Invoice) {
            await axios.post('/invoices', invoice)
            return await dispatch('getInvoices')
        },

        async deleteInvoice({ dispatch }, invoice: Invoice) {
            await axios.delete('/invoices', invoice)
            return await dispatch('getInvoices')
        },

        async getInvoices(_, params) {
            const page = 'page=' + (params?.page ?? 1)
            const perPage = params?.perPage
                ? '&itemPerPage=' + params.perPage
                : ''
            const sortBy = params?.sortBy ? '&sort=' + params.sortBy : ''
            const sortOrder = params?.sortOrder
                ? '&order=' + params.sortOrder
                : ''
            
            const { data } = await axios.get('/api/invoices?' + 
                page +
                perPage +
                sortBy +
                sortOrder
            )

            return data
        },

        async generatePDF(_, params) {            
            const { data } = await axios.get('/api/invoices/generate_invoice?id=' + params.id, 
                {
                    responseType: 'blob' // Important to handle binary data
                }
            )
            return data
        },
    },

    mutations: {
        setInvoices(state: any, invoices) {
            state.invoices = invoices
        },
        setTotalRows(state: any, rows: number) {
            state.totalRows = rows
        },
    },
}

export default invoiceModule
/* jscpd:ignore-end */
